module.exports = "<ul>\n<li>5+ years of professional expertise in the Information Technologies</li>\n<li>Rich experience in Ruby language, Ruby on Rails framework and corresponding infrastructure (used and wrote ruby gems for Riak, AMQP, Redis, MySQL, PostgreSQL, and external APIs)</li>\n<li>Solid experience with different DBs (PostgreSQL, Redis, RabbitMQ)</li>\n<li>Production experience with Javascript (Angular, Vue)</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/summary.md
// module id = pX80
// module chunks = 1